import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    [
      _c(
        VForm,
        { ref: "form" },
        [
          _c(
            VCard,
            {
              staticClass: "mx-auto pa-8 mt-16",
              attrs: { "max-width": "440px", elevation: 10 },
            },
            [
              _c(
                VSheet,
                [
                  _c(
                    VCard,
                    {
                      staticClass:
                        "d-flex flex-md-row flex-column justify-center align-center",
                      attrs: { flat: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-center" },
                        [
                          _vm.companyName == "Panya Factory"
                            ? _c(VImg, {
                                attrs: {
                                  "max-width": "150px",
                                  contain: "",
                                  src: require("@/assets/panya-logo.png"),
                                },
                              })
                            : _c(VImg, {
                                attrs: {
                                  "max-width": "150px",
                                  contain: "",
                                  src: require("@/assets/logo.png"),
                                },
                              }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "text-h5 ml-0 ml-md-5",
                          staticStyle: {
                            "white-space": "nowrap",
                            overflow: "hidden",
                            "text-overflow": "ellipsis",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.companyName) + " ")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(VDivider),
              _c(
                VCardText,
                [
                  _c(
                    "div",
                    { staticClass: "text-h6 d-flex justify-center mb-4" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.login.title")) +
                          " "
                      ),
                    ]
                  ),
                  _c(VTextField, {
                    ref: "emailField",
                    attrs: {
                      solo: "",
                      rules: _vm.userRules,
                      required: "",
                      "data-cy": "loginemail",
                      placeholder: _vm.$vuetify.lang.t("$vuetify.login.email"),
                    },
                    model: {
                      value: _vm.email,
                      callback: function ($$v) {
                        _vm.email = $$v
                      },
                      expression: "email",
                    },
                  }),
                  _c(VTextField, {
                    ref: "passwordField",
                    attrs: {
                      solo: "",
                      "data-cy": "loginpassword",
                      name: "name",
                      rules: _vm.passwordRules,
                      required: "",
                      placeholder: _vm.$vuetify.lang.t(
                        "$vuetify.login.password"
                      ),
                      "append-icon": _vm.showPass ? "mdi-eye" : "mdi-eye-off",
                      type: _vm.showPass ? "text" : "password",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.loginLocal.apply(null, arguments)
                      },
                      "click:append": () => (_vm.showPass = !_vm.showPass),
                    },
                    model: {
                      value: _vm.password,
                      callback: function ($$v) {
                        _vm.password = $$v
                      },
                      expression: "password",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCardActions,
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mx-auto",
                      attrs: {
                        color: "primary",
                        "data-cy": "loginsubmit",
                        disabled: _vm.loading,
                        loading: _vm.loading,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.loginLocal.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t("$vuetify.login.loginSubmit")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(VDivider, { staticClass: "my-5" }),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c("google-sign-in-button", {
                    attrs: { oneTap: false, clientId: _vm.googleClientId },
                    on: { onSuccess: _vm.onGoogleSignIn },
                  }),
                  _c(VSpacer),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }